var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import toFormat from 'date-fns/format';
import * as React from 'react';
import { DATE_FORMAT_FOR_DB, TIME_FORMAT } from '../../constants/constants';
import DatePicker from '../date-picker';
import TimeInput from '../time-input';
import { Styled } from './style';
function formatTimeStringInput(input) {
    if (input.length === 0) {
        return '00';
    }
    else if (input.length === 1) {
        return '0' + input;
    }
    else {
        return input;
    }
}
function getTimeString(dateInput, workInUTC) {
    if (dateInput) {
        if (workInUTC) {
            // todo: get rid of ugly manual formatting when date-fns-tz issue is fixed https://github.com/marnusw/date-fns-tz/issues/55
            var date = new Date(dateInput);
            var hours = formatTimeStringInput(date.getUTCHours().toString());
            var minutes = formatTimeStringInput(date.getUTCMinutes().toString());
            return hours + ":" + minutes;
        }
        else {
            return toFormat(new Date(dateInput), TIME_FORMAT);
        }
    }
    else {
        return '';
    }
}
function getDateString(dateInput, workInUTC) {
    if (dateInput) {
        if (workInUTC) {
            var date = new Date(dateInput);
            var year = date.getUTCFullYear();
            var month = formatTimeStringInput((date.getUTCMonth() + 1).toString());
            var day = formatTimeStringInput((date.getUTCDate()).toString());
            return year + "-" + month + "-" + day;
        }
        else {
            return toFormat(new Date(dateInput), DATE_FORMAT_FOR_DB);
        }
    }
    else {
        return '';
    }
}
function constructDateString(date, time, workInUTC) {
    return date + "T" + time + (workInUTC ? 'Z' : '');
}
var DatetimeInput = /** @class */ (function (_super) {
    __extends(DatetimeInput, _super);
    function DatetimeInput(props) {
        var _this = _super.call(this, props) || this;
        _this.handleDateChange = function (action, selectedDate) {
            if (_this.timeInputRef.current) {
                _this.timeInputRef.current.focus();
                _this.timeInputRef.current.selectionStart = 0;
                _this.timeInputRef.current.selectionEnd = 0;
            }
            _this.setState({
                date: selectedDate,
            });
            var newDatetime = constructDateString(selectedDate, _this.state.time || '00:00', _this.props.workInUTC);
            _this.props.callback(newDatetime);
        };
        _this.handleTimeChange = function (value) {
            if (_this.state.date !== '') {
                _this.setState({
                    time: value,
                });
                var newDatetime = constructDateString(_this.state.date, value, _this.props.workInUTC);
                _this.props.callback(newDatetime);
            }
        };
        _this.timeInputRef = React.createRef();
        var value = props.value;
        _this.state = {
            date: getDateString(value, props.workInUTC),
            time: getTimeString(value, props.workInUTC),
        };
        return _this;
    }
    DatetimeInput.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.value !== this.props.value && this.props.value === '') {
            this.setState({
                date: '',
                time: '',
            });
        }
    };
    DatetimeInput.prototype.render = function () {
        var _a = this.props, autoFocus = _a.autoFocus, minDate = _a.minDate, maxDate = _a.maxDate;
        var date = this.state.date;
        return React.createElement(Styled, __assign({}, this.props, { className: this.props.className }),
            React.createElement(DatePicker, { disabled: this.props.disabled || false, className: "date-picker", placeholder: this.props.placeholder, minDate: minDate, maxDate: maxDate, value: date, showRemove: false, open: this.props.disabled !== true ? autoFocus : false, callBack: this.handleDateChange, locale: this.props.locale }),
            React.createElement(TimeInput, { isDisabled: this.props.disabled || false, forwardRef: this.timeInputRef, className: "time-input", defaultValue: "00:00", value: this.state.time, onTimeValueChange: this.handleTimeChange }));
    };
    return DatetimeInput;
}(React.Component));
export default DatetimeInput;
//# sourceMappingURL=index.js.map